import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { interval, Subscription } from 'rxjs';
import { DataService, GeneralService, LoaderHandlerService, ServicecallService } from 'src/app';
import { TripItem } from 'src/app/model';
import { ChartAttributes } from 'src/app/model/shared/components/entities/entities-profile/chart-builder';
import { DerivedAlerts } from 'src/app/model/shared/components/entities/entities-profile/entities-widgets-collection/geo-playback';
import { WidgetsServiceService } from 'src/app/modules/home/widgets-collection/widgets-service.service';
import { EntitiesServiceService } from 'src/app/shared/services';
import { TripHistoryComponent } from '../../..';

@Component({
  selector: 'app-geo-trace-playback',
  templateUrl: './geo-trace-playback.component.html',
  styleUrl: './geo-trace-playback.component.css'
})
export class GeoTracePlaybackComponent {

  public alertColumnHeader: any = { 'time': 'Time', 'alert': 'Alert Name', 'message': 'Alert Description', 'acknowledged': 'Acknowledged' };
  public telemetryColumHeader: any = {};
  public chartType = new FormControl();
  public entityId = this._router?.url?.split('/')?.[3];
  selectedDate: {tripId: string, start: string, end: string} | Date = null;
  masterMapData: any = [];
  chartSelectedDate: Date[];
  entityDetails: any;
  isloader: boolean = false;
  aggregateDate: { from: Date, to: Date };
  isDrawerOpen = false;
  drawerTitle = 'AI Assist – Trip 0011';
  drawerSubtitle = 'Optimization Summary';
  tripItems: TripItem[] = [];
  summaryData: any;
  showAiAssist: boolean = false;
  tripAssistPlots: [number, number][];
  @ViewChild(TripHistoryComponent) tripHistoryComponent!: TripHistoryComponent;
  selectedTripDetails : {coordinate: [number, number], time: string};
  tripInsightsData : TripItem[] = [];

  public chartTypes = [];

  //Subscription
  private _activeEntityDetailsSubscription: Subscription;
  private _getTripDetailsSubscription: Subscription;
  private _alertListSubscription: Subscription;
  private _paramSubscription: Subscription;
  private _getEntityDetailsSubscription: Subscription;
  private _tripSegmentSubscription: Subscription;
  private _getInsightsSubscription: Subscription;

  private _tenantConfig: any;
  private _categoryTenantConfig: any;
  public telemetryTableData = [];
  private _entitiesMarkerList: any = [];
  public alertTypes: { key: string, displayName: string }[] = [
    { key: 'start', displayName: 'Start' },
    { key: 'stop', displayName: 'Stop' },
    { key: 'clutch', displayName: 'Clutch' },
    { key: 'brake', displayName: 'Brake' },
    { key: 'harshBrake', displayName: 'Harsh Brake' },
    { key: 'gearShifting', displayName: 'Gear Shifting' }
  ];
  public derivedAlerts: DerivedAlerts = { start: false, stop: false, clutch: false, brake: false, harshBrake: false, gearShifting: false };
  public tripName: string;
  public isCollapsed: boolean = false;
  private _dataServiceSubscription: Subscription;
  public chartAttributes: {
    chartAttributes: ChartAttributes, selectedDates: {
      from: Date,
      to: Date,
    },
    order ?: number
  };

  //Data player
  index: number = 0;
  playbackSpeed: number = 1000;
  duration = 0;
  currentTime = 0;
  totalSteps: number = 0;
  isPaused: boolean = false;
  tripId: string;

  constructor(private _router: Router, private _dataSer: DataService, public sharedService: ServicecallService,
    private _generalService: GeneralService, private _service: EntitiesServiceService,
    private _datePipe: DatePipe, private _widgetService: WidgetsServiceService, private changeDetectorRef: ChangeDetectorRef, private loaderHandler: LoaderHandlerService, private _Activatedroute: ActivatedRoute,) {
    this._dataServiceSubscription = this._dataSer.events.subscribe((res: any) => {
      if (res.name === 'apiRefresh' || res.name === 'siteChanged') {
        this.getTelemetryCoordinates();
        this._getAlertData();
      }
    });
  }

  ngOnInit(): any {
    // this.getGeoHistory();
    this._getEntitiesDetails();
    this._paramSubscription = this._Activatedroute.queryParams
      .subscribe(params => {
        if (params['selectedDate']) {
          this.selectedDate = this.sharedService?.getConfiguration('tenantGenericConfig')?.tripHistoryProfilingBasedOn === 'tripId' ? (params['selectedDate'] ? JSON.parse(params['selectedDate']) : null) : new Date(params['selectedDate']);
        }
        if (params['from'] && params['to']) {
          this.aggregateDate = { from: new Date(params['from']), to: new Date(params['to']) }
        }
        if (params['tripName']) {
          this.tripName = params['tripName'];
        }
        if (params['tripId']) {
          this.tripId = params['tripId'];
        }
      })
    this.loaderHandler.toggleLoader(1);
    this.totalSteps = this.masterMapData?.[0]?.polygonData?.length || 0;
    this._entitiesMarkerList = this.sharedService.getConfiguration('trackerEntities') ? this.sharedService.getConfiguration('trackerEntities')['trackerEntitiesList'] : [];
    this._tenantConfig = this.sharedService?.getConfiguration('tenantGenericConfig') ? this.sharedService?.getConfiguration('tenantGenericConfig') : null;
    this.telemetryColumHeader = this._tenantConfig?.geoTelemetryHeader ?? {};
    this.alertColumnHeader = this._tenantConfig?.geoAlertHeader ?? {};
    if(this._tenantConfig?.tripHistoryProfilingBasedOn === 'tripId' && this.tripId) {
      this._getInsights();
    }
    this.getTelemetryCoordinates();
    this._getTripDetails();
  }

  onChartTypeChange(event) {
    // this._dataSer.broadcast('plotChart', {
    //   chartAttributes: this.chartType?.value, selectedDates: {
    //     from: this.chartSelectedDate?.[0],
    //     to: this.chartSelectedDate?.[1]
    //   }
    // });
    this.chartAttributes = {
      chartAttributes: this.chartType?.value, selectedDates: {
        from: this.chartSelectedDate?.[0],
        to: this.chartSelectedDate?.[1]
      }
    }
  }

  alertData: any[] = [];
  alertsHighlighted: any[] = [];

  public transformedAttributeData: any;
  public pager: any = {};
  public totalPages: number[];
  public geotraceDetails: any;

  //Interval
  private intervalSubscription!: Subscription;
  isRunning = false;

  handleBack() {
    this._router.navigateByUrl(`/vehicles/profile/${this._router?.url?.split('/')?.[3]}/trip-history`);
  }

  ngOnDestroy(): any {
    this._activeEntityDetailsSubscription?.unsubscribe();
    this._getTripDetailsSubscription?.unsubscribe();
    this._alertListSubscription?.unsubscribe();
    this._paramSubscription?.unsubscribe();
    this._getEntityDetailsSubscription?.unsubscribe();
    this._dataServiceSubscription?.unsubscribe();
    this._tripSegmentSubscription?.unsubscribe();
    this._getInsightsSubscription?.unsubscribe();
    this.pause();
  }

  /**
   * Gets entities details (To fetch category specific tenant config)
   */
  private _getEntitiesDetails() {
    const entityId = { entityId: this.entityId };
    this._getEntityDetailsSubscription = this.sharedService.getEntityDetails(entityId).subscribe((result: any) => {
      if (result.status) {
        this.entityDetails = result?.response?.data[0];
        this._categoryTenantConfig = this.sharedService.getConfigurationBasedOnCategory(this.entityDetails) ?? {};
        this.chartTypes = this._categoryTenantConfig?.geoPlayBackCharts ?? [];
        this._getAlertData();
      } else {
        this.sharedService.toasterService({ type: 'error', msg: result?.response?.message });
      }
    });
  }


  /**
   * Gets telemetry coordinates
   */
  getTelemetryCoordinates() {
    this.isloader = true;
    let configStartDate = null;
    let configEndDate = null;
    this._tenantConfig = this.sharedService?.getConfiguration('tenantGenericConfig') ? this.sharedService?.getConfiguration('tenantGenericConfig') : null;

    if (this._tenantConfig?.defaultTimeRange) {
      const configHour = this._tenantConfig?.defaultTimeRange || 0;

      const { startDate, endDate } = this.sharedService.calculateDateRange(configHour);
      configEndDate = endDate;
      configStartDate = startDate;
    }
    let startTime;
    let endTime;
    if(this._tenantConfig?.tripHistoryProfilingBasedOn === 'tripId') {
      if(this.selectedDate){
        startTime = this.selectedDate?.['start'];
        endTime =  this.selectedDate?.['end'];
      } else {
        [startTime,endTime] = this._generalService?.getStartEndTimeByDate();
      }
    } else {
      [startTime, endTime] = this.selectedDate ? this._generalService?.getStartEndTimeForSelectedDate(this.selectedDate, this._tenantConfig?.tenant, this._tenantConfig?.defaultTimeRange) : this._generalService?.getStartEndTimeByDate();
    }
    //For chart
    this.chartSelectedDate = [new Date(this.aggregateDate?.from ?? ((!this.selectedDate && configStartDate) ? configStartDate : startTime)), new Date(this.aggregateDate?.to ?? ((!this.selectedDate && configEndDate) ? configEndDate : endTime))];
    const requestData = {
      siteId: this.sharedService.getSiteId(),
      from: this._datePipe.transform(this.aggregateDate?.from ?? ((!this.selectedDate && configStartDate) ? configStartDate : startTime), 'yyyy-MM-ddTHH:mm:ssZZ'),
      to: this._datePipe.transform(this.aggregateDate?.to ?? ((!this.selectedDate && configEndDate) ? configEndDate : endTime), 'yyyy-MM-ddTHH:mm:ssZZ'),
      entityId: this.entityId,
      count: 10000
    };
    this._activeEntityDetailsSubscription = this._widgetService.activeEntityDetails(requestData, 1, true).subscribe({
      next: (result: any) => {
        if (result['status']) {
          if (result['response']['data']?.length) {
            this.loaderHandler.toggleLoader(0);
            let transformedCurrentData = [];
            [...result['response']['data']].forEach((item: any) => {
              const transformedCurrentObj = this.sharedService.flattenObject(item, 'vitals');
              transformedCurrentData.push(transformedCurrentObj);
            });
            this.transformedAttributeData = transformedCurrentData;
            this.transformedAttributeData = this.transformedAttributeData?.reverse();
            this.transformedAttributeData?.map((elem: any) => {
              elem['time'] = this.sharedService.getLastSeenFormat(elem.sourceTimestamp);
              if (!elem['attrValid']) {
                elem['attrValid'] = false;
              }
              elem.attributes?.forEach((item: any) => {
                if (item?.attributeName === 'RUL_BRAKE_PAD' || item?.attributeName === 'RUL_CLUTCH_PAD') {
                  elem[item.attributeName + '_Time'] = item.processedTime;
                }
              });
            });
            const coordArray = this.transformedAttributeData?.map((data: any) => [
              data?.lat,
              data?.long,
            ]);
            if (this.index === 0) {
              this.masterMapData = [
                {
                  polygonData: coordArray,
                  currentCoordinate: coordArray?.[0],
                  upcomingCoordinate: coordArray?.[1]
                },
              ];
              this.totalSteps = this.masterMapData?.[0]?.polygonData?.length || 0;
              this.telemetryTableData = this.transformedAttributeData?.slice(0, 2);
              for (let index = 0; index < this.telemetryTableData?.length; index++) {
                if (index === 0) {
                  this.telemetryTableData[index] = { ...this.telemetryTableData[index], current: true }
                }
              }
              this.telemetryTableData.unshift({});
            }
            transformedCurrentData = [];
            // this.clearUnwantedValues();
            if (result['response']['pageInfo']) {
              this.pager = { ...result['response']['pageInfo'] };
            }
          } else {
            this.transformedAttributeData = [];
            this.totalPages = [];
            if (result?.response?.message)
              this.sharedService.toasterService({ type: 'error', msg: result?.response?.message });
          }
        }
        else {
          this.loaderHandler.toggleLoader(0);
          this.transformedAttributeData = [];
          if (result?.response?.message)
            this.sharedService.toasterService({ type: 'error', msg: result?.response?.message });
        }
        this.isloader = false;
      }, error: (error) => {
        if (error) {
          this.transformedAttributeData = [];
          this.isloader = false;
        }
      }
    });

  }

  /**
   * Gets trip details (To fetch locations)
   */
  private _getTripDetails() {
    let configStartDate = null;
    let configEndDate = null;
    this._tenantConfig = this.sharedService?.getConfiguration('tenantGenericConfig') ? this.sharedService?.getConfiguration('tenantGenericConfig') : null;

    if (this._tenantConfig?.defaultTimeRange) {
      const configHour = this._tenantConfig?.defaultTimeRange || 0;

      const { startDate, endDate } = this.sharedService.calculateDateRange(configHour);
      configEndDate = endDate;
      configStartDate = startDate;
    }
    let startTime;
    let endTime;
    if(this._tenantConfig?.tripHistoryProfilingBasedOn === 'tripId') {
      if(this.selectedDate){
        startTime = this.selectedDate?.['start'];
        endTime =  this.selectedDate?.['end'];
      } else {
        [startTime,endTime] = this._generalService?.getStartEndTimeByDate();
      }
    } else {
      [startTime, endTime] = this.selectedDate ? this._generalService?.getStartEndTimeForSelectedDate(this.selectedDate, this._tenantConfig?.tenant, this._tenantConfig?.defaultTimeRange) : this._generalService?.getStartEndTimeByDate();
    }
    const _reqPayload = {
      entityId: this.entityId,
      siteId: this.sharedService.getSiteId(),
      from: this._datePipe.transform(this.aggregateDate?.from ?? ((!this.selectedDate && configStartDate) ? configStartDate : startTime), 'yyyy-MM-ddTHH:mm:ssZZ'),
      to: this._datePipe.transform(this.aggregateDate?.to ?? ((!this.selectedDate && configEndDate) ? configEndDate : endTime), 'yyyy-MM-ddTHH:mm:ssZZ'),
    };
    this._getTripDetailsSubscription = this._service
      .getEntitySummary(_reqPayload)
      .subscribe({
        next: (result: any) => {
          this.geotraceDetails = result;
        },
        error: () => {
          this.geotraceDetails = {};
        },
      });
  }

  /**
   * Gets alert data
   */
  private _getAlertData() {
    let configStartDate = null;
    let configEndDate = null;
    this._tenantConfig = this.sharedService?.getConfiguration('tenantGenericConfig') ? this.sharedService?.getConfiguration('tenantGenericConfig') : null;

    if (this._tenantConfig?.defaultTimeRange) {
      const configHour = this._tenantConfig?.defaultTimeRange || 0;

      const { startDate, endDate } = this.sharedService.calculateDateRange(configHour);
      configEndDate = endDate;
      configStartDate = startDate;
    }
    let startTime;
    let endTime;
    if(this._tenantConfig?.tripHistoryProfilingBasedOn === 'tripId') {
      if(this.selectedDate){
        startTime = this.selectedDate?.['start'];
        endTime =  this.selectedDate?.['end'];
      } else {
        [startTime,endTime] = this._generalService?.getStartEndTimeByDate();
      }
    } else {
      [startTime, endTime] = this.selectedDate ? this._generalService?.getStartEndTimeForSelectedDate(this.selectedDate, this._tenantConfig?.tenant, this._tenantConfig?.defaultTimeRange) : this._generalService?.getStartEndTimeByDate();
    }
    //For Chart
    this.chartSelectedDate = [new Date(this.aggregateDate?.from ?? ((!this.selectedDate && configStartDate) ? configStartDate : startTime)), new Date(this.aggregateDate?.to ?? ((!this.selectedDate && configEndDate) ? configEndDate : endTime))];
    this.chartType?.setValue(this.chartTypes?.[0]?.value);
    this.chartAttributes = {
      chartAttributes: { ...this.chartTypes?.[0]?.value, ...{ entityNames: [{ _id: this.entityId, uniqueId: this.entityDetails?.uniqueId }] } }, selectedDates: {
        from: this.chartSelectedDate?.[0],
        to: this.chartSelectedDate?.[1]
      }
    }
    const reqData = {
      filterBy: "Alert",
      classType: "Alert",
      page: 1,
      autoClose: false,
      filterList: [],
      entityId: this.entityId,
      zoneId: null,
      from: this._datePipe.transform(this.aggregateDate?.from ?? ((!this.selectedDate && configStartDate) ? configStartDate : startTime), 'yyyy-MM-ddTHH:mm:ssZZ'),
      to: this._datePipe.transform(this.aggregateDate?.to ?? ((!this.selectedDate && configEndDate) ? configEndDate : endTime), 'yyyy-MM-ddTHH:mm:ssZZ'),
      siteId: this.sharedService.getSiteId(),
      entityCategory: this.sharedService.getConfiguration('tenantCategory') ? this.sharedService.getConfiguration('tenantCategory').tenantCategory?.category : null,
      limit: 10000
    };
    this._alertListSubscription = this.sharedService.alertList(reqData).subscribe((result: any) => {
      if (result['status']) {
        if (result['response'].length) {
          this.alertData = [...result['response']];
          this.alertData.map((item: any) => {
            item.originalTime = item.time;
            item.time = this.sharedService.getLastSeenFormat(item?.time);
            item.acknowledged = item.status === true ? 'Active' : ((item.status === false && !item.state) ? 'Acknowledged' : 'Invalid');
            item.status = item.status === true ? 'Active' : 'Acknowledged';
            item.ackBy = item.ackBy ? item.ackBy : "--";
            item.ackTime = item.ackTime !== 'null' ? this.sharedService.getLastSeenFormat(item?.ackTime) : "--";
            item.vehicle = "KL01BX-- -- --";
            item.entityType = 'alerts';
            item.entityModule = this._setEntityType(item.entityCategory);
            item.destination = item.destination ? item.destination : '--';
            item.attributeValue = item.attributeValue ? '' + item.attributeValue : "--";
          });
          this.alertsHighlighted = [...this.alertData];
        }
        else {
          this.alertData = [];
        }
        if (result['pageInfo']) {
          this.pager = { ...result['pageInfo'] };
        }
      } else {
        this.alertData = [];
        this.sharedService.toasterService({ type: 'error', msg: result?.response?.message });
      }
    });
  }

  /**
 * Sets entity type
 * @param category 
 * @returns  
 */
  private _setEntityType(category: any) {
    const filteredEntityEntityModule = this._entitiesMarkerList.find((entity: any) => entity.entityCategory === category);
    return filteredEntityEntityModule ? this._setRoute(+filteredEntityEntityModule.entityModule) : '';
  }

  /**
   * Sets route
   * @param entityModule 
   * @returns  
   */
  private _setRoute(entityModule: number) {
    switch (entityModule) {
      case 1: return 'vehicles';
      case 2: return 'assets';
      case 3: return 'people';
      default: return 'assets';
    }
  }

  public expandMap() {
    this.isCollapsed = !this.isCollapsed;
  }

  startInterval(): void {
    if (!this.isRunning) {
      this.index = this.index || 0; // Maintain index when resuming

      const mapObject = this.masterMapData?.[0];
      if (!mapObject || !mapObject.polygonData?.length) return;
      if (!this.transformedAttributeData?.length) return;

      this.totalSteps = mapObject.polygonData.length; // Ensure slider has correct max value

      this.intervalSubscription = interval(this.playbackSpeed)?.subscribe({
        next: () => this.updatePlayback(),
        complete: () => console.log("Interval completed."),
      });

      this.isRunning = true;
    }
  }

  // Update playback state
  updatePlayback(): void {
    this.derivedAlerts = { start: false, stop: false, clutch: false, brake: false, harshBrake: false, gearShifting: false };
    const mapObject = this.masterMapData?.[0];
    if (!mapObject) return;

    // Update UI elements
    // this.index = Math.min(this.index, this.totalSteps - 1);
    const nextCoordinate = mapObject.polygonData[this.index];
    const upcomingCoordinate = mapObject.polygonData[this.index + 1];

    const prevItem = this.index > 0 ? this.transformedAttributeData[this.index - 1] : {};
    const currentItem = { ...this.transformedAttributeData[this.index], current: true };
    const nextItem = this.index + 1 < this.transformedAttributeData.length ? this.transformedAttributeData[this.index + 1] : {};

    if (currentItem?.['altbs6.PacketType']) {
      const packetType = currentItem['altbs6.PacketType'];
      this.derivedAlerts.start = packetType === 'IN';
      this.derivedAlerts.stop = packetType === 'IF';
      this.derivedAlerts.harshBrake = packetType === 'HB';
    }

    this.derivedAlerts.clutch = Boolean(currentItem?.['can2bs6.ClutchSwitch']);
    this.derivedAlerts.brake = Boolean(currentItem?.['can2bs6.BrakeSwitch']);

    this.derivedAlerts.gearShifting =
      currentItem?.['can2bs6.TransmissionCurrentGear'] !==
      prevItem?.['can2bs6.TransmissionCurrentGear'];

    this.alertData = this.alertData?.map((item) => ({
      ...item,
      current: item?.originalTime === currentItem?.sourceTimestamp,
    }));

    const currentAlertIndex = this.alertData?.findIndex(item => item.current);
    const prevAlert = this.alertData?.[this.alertData?.findIndex(item => item.current) - 1] ?? {};
    const currentAlert = this.alertData?.[this.alertData?.findIndex(item => item.current)];
    const nextAlert = this.alertData?.[this.alertData?.findIndex(item => item.current) + 1] ?? {};

    if (currentAlertIndex !== -1) {
      this.alertsHighlighted = [prevAlert, currentAlert, nextAlert];
    } else {
      this.alertsHighlighted = [...this.alertData];
    }

    this.masterMapData = [{
      ...mapObject, currentCoordinate: nextCoordinate ? [...nextCoordinate] : null, upcomingCoordinate: upcomingCoordinate ? [...upcomingCoordinate] : null,
      alertCoordinate: currentAlert ? [currentAlert?.latitude, currentAlert?.longitude] : null, alertSeverity: currentAlert ? this.getSeverityColor(currentAlert?.severity) : null
    }];
    this.telemetryTableData = [prevItem, currentItem, nextItem];

    this.changeDetectorRef?.detectChanges();

    // Move to the next index
    this.index++;

    // Stop at the last step
    if (this.index >= this.totalSteps) {
      console.log("Reached the last coordinate. Stopping interval.");
      this.pause();
    }
  }

  // Pause playback
  pause(): void {
    this.intervalSubscription?.unsubscribe();
    this.isRunning = false;
    this.isPaused = true;
  }

  // Resume playback
  resume(): void {
    if (!this.isRunning) {
      this.startInterval();
      this.isPaused = false;
    }
  }

  // Fast forward
  fastForward(): void {
    if (this.index + 1 < this.totalSteps) {
      // this.index++;
      this.updatePlayback();
    }
  }

  // Rewind
  rewind(): void {
    if (this.index > 1) {
      this.index -= 2;
      this.updatePlayback();
    }
  }

  onSliderChange(event: Event): void {
    if (+(event.target as HTMLInputElement).value < this.totalSteps) {
      this.index = +(event.target as HTMLInputElement).value;
    } else {
      this.index = this.totalSteps - 1;
    }
    this.isPaused = true; //To fix map initializing error
    this.seek();
  }

  // Seek to position when slider is moved
  seek(): void {
    this.updatePlayback();
  }

  // Adjust playback speed
  setSpeed(speedMs: number): void {
    this.playbackSpeed = +speedMs;
    if (this.isRunning) {
      this.pause();
      this.resume();
    }
  }

  // Format time for display (mm:ss)
  formatTime(stepIndex: number): string {
    const elapsedMs = stepIndex * this.playbackSpeed; // Convert steps to milliseconds
    const totalSeconds = Math.floor(elapsedMs / 1000); // Convert to seconds
    const min = Math.floor(totalSeconds / 60);
    const sec = totalSeconds % 60;
    return `${min}:${sec < 10 ? '0' : ''}${sec}`;
  }

  selectedAlert(alert: any) {
    this.index = this.transformedAttributeData?.findIndex(data => data.sourceTimestamp === alert?.originalTime);
    this.updatePlayback();
  }

  getSeverityColor(severity: string) {
    if (severity === 'major') {
      return '#fccc70';
    } else if (severity === 'minor') {
      return '#c2d0df';
    } else if (severity === 'critical') {
      return '#dd1a31';
    } else {
      return null;
    }
  }

  // getDrawerInput(event: any): void {
  //   if (event?.action === 'openDrawer') {
  //     this.summaryData = event?.data ?? null;
  //     console.log(this.summaryData);
  //     this.openDrawer();
  //   }
  // }

  // openDrawer(): void {
  //   this.isDrawerOpen = true;
  //   this.loadTripData(); // Refresh data when opening
  // }

  /**
   * Handles tile detail from Trip History (child) component
   * @param tile 
   */
  handleTileDetail(tile: any) {
    this.summaryData = {
      ...tile,
      selectedDate: this.selectedDate,
      aggregateDate: this.aggregateDate,
      tripId: this.tripId,
      entityDetails: this.entityDetails
    };    
    this.drawerTitle = `AI Assist – ${this.summaryData?.tripName}`;
  }

  /**
   * Gets trips and open drawer
   */
  getTrips() {
    this.tripHistoryComponent?.emitTripDetail();
    this.isCollapsed = true;
    this.showAiAssist = true;
    this.isDrawerOpen = true;
    this.loadTripData(); // Refresh data when opening
  }

  /**
   * Closes drawer
   */
  closeDrawer(): void {
    this.isCollapsed = false;
    this.showAiAssist = false;
    this.isDrawerOpen = false;
    this.tripAssistPlots = null;
  }

  /**
   * Loads trip segments data
   */
  private loadTripData(): void {
    let configStartDate = null;
    let configEndDate = null;
    this._tenantConfig = this.sharedService?.getConfiguration('tenantGenericConfig') ? this.sharedService?.getConfiguration('tenantGenericConfig') : null;

    if (this._tenantConfig?.defaultTimeRange) {
      const configHour = this._tenantConfig?.defaultTimeRange || 0;

      const { startDate, endDate } = this.sharedService.calculateDateRange(configHour);
      configEndDate = endDate;
      configStartDate = startDate;
    }
    let startTime;
    let endTime;
    if(this._tenantConfig?.tripHistoryProfilingBasedOn === 'tripId') {
      if(this.selectedDate){
        startTime = this.selectedDate?.['start'];
        endTime =  this.selectedDate?.['end'];
      } else {
        [startTime,endTime] = this._generalService?.getStartEndTimeByDate();
      }
    } else {
      [startTime, endTime] = this.selectedDate ? this._generalService?.getStartEndTimeForSelectedDate(this.selectedDate, this._tenantConfig?.tenant, this._tenantConfig?.defaultTimeRange) : this._generalService?.getStartEndTimeByDate();
    }
    const reqPayload = {
      entityId: this.entityId,
      from: this._datePipe.transform(this.aggregateDate?.from ?? ((!this.selectedDate && configStartDate) ? configStartDate : startTime), 'yyyy-MM-ddTHH:mm:ssZZ'),
      to: this._datePipe.transform(this.aggregateDate?.to ?? ((!this.selectedDate && configEndDate) ? configEndDate : endTime), 'yyyy-MM-ddTHH:mm:ssZZ'),
      type: "PrescriptiveInsights_TripSegment",
      ...(this.tripId && {tripId: this.tripId})
    }
    this._tripSegmentSubscription = this.sharedService.getTripSegments(reqPayload).subscribe({
      next: (result: any) => {
        this.tripItems = Array.isArray(result)? [...result]?.sort((a: any, b: any) => new Date(b?.dataFrom || 0).getTime() - new Date(a?.dataFrom || 0).getTime())?.map((item, index, arr) => 
        ({ ...item, tripLabel: 'T' + (arr.length - index)?.toString()?.padStart(4, '0')})) : [];
        const matchedTimestamps = new Set<string>();

        this.tripItems?.forEach(trip => {
          const match = this.getMatchingDate(this.transformedAttributeData, trip.dataFrom);
          if (match?.sourceTimestamp) {
            matchedTimestamps?.add(match.sourceTimestamp);
            const matchedCoordinate = this.transformedAttributeData?.find(item => item.sourceTimestamp === match.sourceTimestamp);
            trip.currentLocation = [matchedCoordinate?.lat , matchedCoordinate?.long];
          }
        });
        const coordArray = this.transformedAttributeData?.filter(item => matchedTimestamps?.has(item.sourceTimestamp))?.map((item: any) => [item.lat, item.long]);
  
        this.tripAssistPlots = [...coordArray];
      }, error: () => {
        this.tripItems = [];
      }
    })

  }

  /**
   * Gets insights
   */
  private _getInsights() {
    const _reqPayload = {
      type : 'PrescriptiveInsights_TripSegment',
      ...(this.tripId && {tripIds: [this.tripId]})
    };
    this._getInsightsSubscription = this.sharedService
    .getInsight(_reqPayload)
    .subscribe({
      next: (result: any) => {
        this.tripInsightsData = Array.isArray(result) ? [...result] : [];
      },
      error: () => {
        this.tripInsightsData = [];
      },
    });
  }

  /**
   * Gets matching date using binary search
   * @param dataArray 
   * @param targetTime 
   * @returns matching date 
   */
  getMatchingDate(dataArray: any[], targetTime: string): any {
    const targetMs = Date.parse(targetTime);
    let minIndex = 0, maxIndex = dataArray.length - 1;
    let result = null;

    while (minIndex <= maxIndex) {
      const mid = Math.floor((minIndex + maxIndex) / 2);
      const midTime = Date.parse(dataArray[mid]?.sourceTimestamp);

      if (midTime <= targetMs) {
        result = dataArray[mid];
        minIndex = mid + 1;
      } else {
        maxIndex = mid - 1;
      }
    }

    return result;
  }

  onTripItemClick(item: TripItem): void {
    // console.log('Trip item clicked:', item);
  }
}
